import { APP_NAME, CONTACT_EMAIL, CONTACT_MAILTO } from "../../lib/contact";
import { CURRENT_TERMS_VERSION } from "../../lib/terms";
import { PublicChrome } from "./PublicChrome";

export function TermsPage() {
  return (
    <PublicChrome>
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16" data-testid="terms-page">
        <p className="text-sm font-bold uppercase tracking-wide text-brand">Informacje prawne</p>
        <h1 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
          Regulamin korzystania z aplikacji {APP_NAME}
        </h1>
        <p className="mt-4 text-sm text-muted">Wersja: {CURRENT_TERMS_VERSION}</p>

        <div className="mt-10 space-y-10 text-base leading-relaxed">
          <section>
            <h2 className="text-xl font-bold">1. Postanowienia ogólne</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Niniejszy regulamin określa zasady korzystania z aplikacji {APP_NAME} (dalej:
                „Aplikacja”), świadczonej drogą elektroniczną przez administratora serwisu.
              </p>
              <p>
                Korzystanie z Aplikacji wymaga założenia konta i akceptacji niniejszego regulaminu
                oraz polityki prywatności.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">2. Faza beta — bezpłatny dostęp</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Aplikacja jest obecnie udostępniana w fazie <strong>beta</strong> — korzystanie z
                pełnej funkcjonalności jest w tym okresie <strong>bezpłatne</strong>.
              </p>
              <p>
                Administrator planuje wprowadzenie płatnych planów subskrypcyjnych. O terminie
                uruchomienia płatności użytkownicy zostaną poinformowani co najmniej{" "}
                <strong>30 dni wcześniej</strong> drogą mailową oraz komunikatem w Aplikacji.
              </p>
              <p>
                Konta założone w fazie beta mogą otrzymać preferencyjne warunki po uruchomieniu
                płatności — szczegóły zostaną ogłoszone przed startem płatnych planów.
              </p>
              <p>
                Cennik zostanie opublikowany przed uruchomieniem płatności. Do tego czasu
                informacje o orientacyjnych planach nie stanowią wiążącej oferty handlowej.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">3. Konto użytkownika</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Użytkownik zakłada konto podając adres e-mail i hasło (lub logując się przez
                Google). Konto jest przypisane do jednego użytkownika i jednego stada danych.
              </p>
              <p>
                Użytkownik odpowiada za bezpieczeństwo danych logowania oraz za treść danych
                wprowadzanych do Aplikacji.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">4. Zakres usługi</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Aplikacja umożliwia zarządzanie danymi stada (zwierzęta, rozród, wykoty, zasoby
                kolczyków, kontrole, finanse gospodarstwa, integracja z IRZplus). Zakres funkcji może
                ulegać zmianie w trakcie rozwoju produktu.
              </p>
              <p>
                Administrator dokłada starań, aby Aplikacja działała niezawodnie, jednak nie gwarantuje
                nieprzerwanego dostępu (np. z powodu konserwacji, awarii infrastruktury lub braku
                łączności po stronie użytkownika).
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">5. Płatności (przyszłość)</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Po zakończeniu fazy beta wprowadzone zostaną plany płatne. Szczegóły (ceny, limity,
                sposób płatności) zostaną podane w cenniku przed uruchomieniem płatności.
              </p>
              <p>
                Płatności będą obsługiwane przez zewnętrznego operatora płatności. Faktury VAT
                będą wystawiane zgodnie z obowiązującymi przepisami.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">6. Odpowiedzialność</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Aplikacja wspiera prowadzenie ewidencji stada, ale nie zastępuje obowiązków
                urzędowych ani decyzji hodowlanych użytkownika. Użytkownik samodzielnie weryfikuje
                dane przed zgłoszeniami do ARiMR/IRZplus.
              </p>
              <p>
                Administrator nie ponosi odpowiedzialności za utratę danych wynikającą z działań
                użytkownika (np. udostępnienie hasła osobom trzecim) lub siły wyższej.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">7. Usunięcie konta</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Użytkownik może w każdej chwili złożyć wniosek o usunięcie konta w ustawieniach
                Aplikacji lub mailowo na adres{" "}
                <a className="font-semibold text-brand hover:underline" href={CONTACT_MAILTO}>
                  {CONTACT_EMAIL}
                </a>
                .
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold">8. Zmiany regulaminu</h2>
            <div className="mt-4 space-y-3 text-muted">
              <p>
                Administrator może zmienić regulamin. O istotnych zmianach użytkownicy zostaną
                poinformowani z co najmniej 30-dniowym wyprzedzeniem (e-mail lub komunikat w
                Aplikacji).
              </p>
              <p>
                Dalsze korzystanie z Aplikacji po wejściu w życie zmian oznacza akceptację nowego
                regulaminu, chyba że użytkownik usunie konto przed tą datą.
              </p>
            </div>
          </section>
        </div>
      </main>
    </PublicChrome>
  );
}
